import Image from 'next/image'

function ActionPlanIcon( { complete } ) {
  // const { bg, fg1, fg2 } = getIconColors( complete )
  
  return (
    <Image width={ 100 } height={ 100 } sizes="100vw" style={ { width: '100%', aspectRatio: '1' } } src={ complete ? '/images/icons/action-plan-colour.png' : '/images/icons/action-plan-grey.png' } alt="Action plan icon" />  
  )
}

export default ActionPlanIcon
